if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// ADD DATA-ATTR TO BTNs
const addBTNsLabel = () => {
	document.querySelectorAll('.btn, .signup-btn').forEach((btn) => {
		btn.setAttribute('data-label', btn.textContent);
	});
};

(function () {
	// MOBILE NAV - HOME ACTIVE STATE
	document.querySelectorAll('.nav-home').forEach((link) => {
		if (document.body.id === 'home') {
			link.classList.add('active');
		}
	});

	// TOGGLE TARGET 'visible' CLASS ON CLICK
	document.querySelectorAll('.js-slidetarget').forEach((btn, i) => {
		const target = document.querySelector(btn.getAttribute('href'));

		if (target) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				target.classList.toggle('visible');
				if (target.classList.contains('visible')) goto(btn.getAttribute('href').replace('#', ''));
			});

			// USE URL HASH TO OPEN TARGET
			const match_conditions = !btn.classList.contains('hiddenForm_close') && i === 0 && window.location.hash === btn.getAttribute('href');
			if (match_conditions) btn.click();
		}
	});

	// CUSTOM SELECT
	document.querySelectorAll('[data-custom_select]').forEach((select) => {
		const currentField = select.querySelector('input');

		if (currentField) {
			currentField.addEventListener('click', () => select.classList.toggle('active'));
		}

		select.querySelectorAll('li').forEach((li) => {
			li.addEventListener('click', () => {
				if (currentField) {
					currentField.value = li.dataset.value;
				}

				select.querySelectorAll('li').forEach((l) => l.classList.remove('active'));
				li.classList.add('active');

				select.classList.remove('active');
			});
		});
	});

	// CLOSE MAIN NAV MOBILE
	document.querySelectorAll('.close-menu').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.remove('active');
			});
		}
	});

	// OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-show_nav_m]').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.add('active');
			});
		}
	});

	// ATTRACTIONS LIST FILTER
	document.querySelectorAll('.attractionsListMod').forEach((mod) => {
		mod.querySelectorAll('.attractionsListMod_filter-item').forEach((btn) => {
			btn.addEventListener('click', () => {
				mod.querySelectorAll('.attractionsListMod_filter-item').forEach((b) => b.classList.remove('active'));
				btn.classList.add('active');

				mod.querySelectorAll('.attractionsListMod_item').forEach((item) => item.classList.remove('active'));
				mod.querySelectorAll(`.attractionsListMod_item[data-cat="${btn.dataset.cat}"]`).forEach((item, i) => {
					if (i === 0) {
						item.classList.add('first');
					}
					setTimeout(() => item.classList.add('active'), 1);
				});

				if (btn.dataset.cat === 'all') {
					mod.querySelectorAll(`.attractionsListMod_item`).forEach((item) => {
						setTimeout(() => item.classList.add('active'), 1);
					});
				}
			});
		});
	});

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenusMod').forEach((mod) => {
		mod.querySelectorAll('.restMenusMod_nav-btn').forEach((btn) => {
			btn.addEventListener('click', () => {
				mod.querySelectorAll('.restMenusMod_nav-btn').forEach((b) => b.classList.remove('active'));
				btn.classList.add('active');

				mod.querySelectorAll('.restMenusMod_menu').forEach((menu) => menu.classList.remove('active'));
				mod.querySelector(`.restMenusMod_menu[data-id="${btn.dataset.id}"]`).classList.add('active');
			});
		});
	});

	// CLONE QUAD GALLERY LIST
	document.querySelectorAll('.galleryMod').forEach((mod) => {
		if (!mod.dataset.is_mobile) {
			const track = mod.querySelector('.galleryMod_track');
			const listClone = mod.querySelector('.galleryMod_list').cloneNode(true);

			if (track && listClone) {
				listClone.setAttribute('data-fromjs', '');
				track.appendChild(listClone);
			}
		}
	});

	addBTNsLabel();

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	// FANCYBOX SETTINGS
	$.fancybox.defaults.touch = false;
	$.fancybox.defaults.autoFocus = false;
	$.fancybox.defaults.backFocus = false;
	$.fancybox.defaults.smallBtn = true;
	$.fancybox.defaults.btnTpl.smallBtn = `<button class="fancybox-button fancybox-close-small" title="{{CLOSE}}" type="button" data-fancybox-close><svg fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><line x1="1" y1="1" x2="17" y2="17" /><line x1="17" y1="1" x2="1" y2="17" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowLeft = `<button class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" type="button" data-fancybox-prev><span>Prev</span><svg width="14" height="28" viewBox="0 0 14 28" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 14 0 L 1 14 L 14 28" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowRight = `<button class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" type="button" data-fancybox-next><span>Next</span><svg width="14" height="28" viewBox="0 0 14 28" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 0 0 L 14 14 L 0 28" /></svg></button>`;

	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	// SWIPER
	const swiperClass = '.sym-slides';
	const swiperOps = {
		loop: true,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		const combinedOps = Object.assign({}, swiperOps, dataOps);

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');

		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	// GO TO SLIDE FROM URL PARAMs
	const url_params = new URLSearchParams(window.location.search);
	const url_slider = url_params.get('slider');
	const url_slide = parseInt(url_params.get('slide'));
	document.querySelectorAll(`[data-sliderid="${url_slider}"]`).forEach((slider) => {
		slider.swiper.slideTo(url_slide);
	});

	// SPECIALS T&C TOGGLE
	$('.specialsTerms_link').click(function (e) {
		e.preventDefault();
		const $link = $(this);

		if ($($.attr(this, 'href')).length > 0) {
			$($.attr(this, 'href'))
				.stop()
				.slideToggle(500, function () {
					$link.toggleClass('active', $(this).is(':visible'));
				});
		}
	});

	// RESTAURANT MENUS FILTER
    document.querySelectorAll('.restMenus_filter button').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.restMenus_filter button').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            document.querySelectorAll('.restMenus_item').forEach(room => {
                room.classList.remove('active');
                if (btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag) {
                    room.classList.add('active');
                }
            });
        });

        if (i === 0) btn.click();
    });

	// RESTAURANT MENUS FILTER
    document.querySelectorAll('.restMenus_filterMobile select').forEach((filter, i) => {
        filter.addEventListener('change', _ => {
            document.querySelectorAll('.restMenus_item').forEach(room => {
                room.classList.remove('active');
                if (filter.value === room.dataset.tag) {
                    room.classList.add('active');
                }
            });
        });

        if (i === 0) {
            let eventChange = document.createEvent('HTMLEvents');
            eventChange.initEvent('change', true, false);
            filter.dispatchEvent(eventChange);
        }
    });



	// RESTAURANT MENUS FILTER 2
    document.querySelectorAll('.options_cotainer span').forEach((filter, i) => {
        filter.addEventListener('click', _ => {
            document.querySelectorAll('.restMenus_item').forEach(room => {
                room.classList.remove('active');
                if (filter.textContent === room.dataset.tag) {
                    room.classList.add('active');
                }
            });
        });

        if (i === 0) {
            let eventChange = document.createEvent('HTMLEvents');
            eventChange.initEvent('change', true, false);
            filter.dispatchEvent(eventChange);
        }
    });


})();
